import { render } from "./DialogInitialLoading.vue?vue&type=template&id=1a3b8cbd"
import script from "./DialogInitialLoading.vue?vue&type=script&lang=js"
export * from "./DialogInitialLoading.vue?vue&type=script&lang=js"
script.render = render

export default script